import {
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { PER_PAGE_DEFAULT, QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { useMemo } from "react";
import { fetchSalaryWorkers } from "./salaryWorkers";

export const fetchProvisionWorkers = async () => {
  return fetchSalaryWorkers(getCompanyId());
};

// export const fetchWorkers = async () => {
//   return await axios({
//     method: "get",
//     url: SERVICES.WORKERS,
//     params: {
//       page: 1,
//       per_page: PER_PAGE_DEFAULT,
//       "q[company_id_eq]": getCompanyId(),
//     },
//   }).then((res) => res.data || []);
// };

export const fetchProvisionItems = async (companyId: any) => {
  return await axios({
    method: "get",
    url: SERVICES.PROVISION_ITEMS,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
    },
  }).then((res) => res.data || []);
};

// const fetchDivisions = async (companyId: any) => {
//   return await axios({
//     method: "get",
//     url: `${SERVICES.COMPANIES}/${companyId}/tree`,
//     params: {
//       model_name: "division",
//       name_only: true,
//     },
//   }).then((res) => res.data || []);
// };

// const fetchBranches = async (companyId: any) => {
//   return await axios({
//     method: "get",
//     url: `${SERVICES.COMPANIES}/${companyId}/tree`,
//     params: {
//       model_name: "branch",
//     },
//   }).then((res) => res.data || []);
// };

// const fetchDepartments = async (companyId: any) => {
//   return await axios({
//     method: "get",
//     url: `${SERVICES.COMPANIES}/${companyId}/tree`,
//     params: {
//       model_name: "department",
//       name_only: true,
//     },
//   }).then((res) => res.data || []);
// };

export const fetchProvisions = async (year: any, companyId: any) => {
  return await axios({
    method: "get",
    url: SERVICES.PROVISIONS,
    baseURL: process.env.REACT_APP_API_URL_V2,
    params: {
      company_id: companyId,
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      "q[year_cycle_eq]": year,
    },
  }).then((res) => res.data || []);
};

export const fetchOrgs = async (companyId: any) => {
  return await axios({
    method: "get",
    url: `${SERVICES.ORGS}/orgs_for_provision_page`,
    params: {
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      "q[company_id_eq]": companyId,
      current_company_id: companyId,
    },
  }).then((res) => res.data || []);
};

const fetchCompanies = async () => {
  return await axios({
    method: "get",
    url: `${SERVICES.COMPANIES}/companies_for_company_bar`,
    params: {
      page: 1,
      per_page: PER_PAGE_DEFAULT,
      scope: "list_all",
    },
  }).then((res) => res.data || []);
};

export const useProvisionConfigs = (year: unknown) => {
  return useMemo(
    () => ({
      staleTime: 300,
      cacheTime: 300,
      // retry: 1,
      enabled: !!year,
    }),
    [year],
  );
};

export const usePromiseSettledProvisions = (year: any) => {
  const companyId = getCompanyId();
  const queryConfig = useProvisionConfigs(year);

  return useQueries({
    queries: [
      // {
      //   queryKey: [QUERY_NAME.PROVISIONS, 1, year],
      //   queryFn: () => fetchWorkers(),
      //   ...queryConfig,
      // },
      {
        queryKey: ["QUERY_NAME.PROVISIONS", 1, year, companyId],
        queryFn: () => fetchProvisions(year, companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.PROVISIONS", 2, companyId],
        queryFn: () => fetchProvisionItems(companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.PROVISIONS", 3, companyId],
        queryFn: () => fetchOrgs(companyId),
        ...queryConfig,
      },
      {
        queryKey: ["QUERY_NAME.PROVISIONS", 4, companyId],
        queryFn: () => fetchCompanies(),
        ...queryConfig,
      },
    ],
  });
};

export const useProvisionWorkers = (year: number | string) => {
  const queryConfig = useProvisionConfigs(year);

  return useQuery({
    queryKey: [QUERY_NAME.PROVISIONS, "workers", year, getCompanyId()],
    queryFn: () => fetchProvisionWorkers(),
    ...queryConfig,
  });
};

export const useProvisionItems = (year: number | string) => {
  const companyId = getCompanyId();
  const queryConfig = useProvisionConfigs(year);

  return useQuery({
    queryKey: [
      // QUERY_NAME.PROVISIONS,
      2,
      year,
    ],
    queryFn: () => fetchProvisionItems(companyId),
    ...queryConfig,
  });
};

export const useProvisionsData = (year: number | string) => {
  const companyId = getCompanyId();
  const queryConfig = useProvisionConfigs(year);

  return useQuery({
    queryKey: [
      // QUERY_NAME.PROVISIONS,
      3,
      year,
    ],
    queryFn: () => fetchProvisions(year, companyId),
    ...queryConfig,
  });
};

export const useProvisionOrgs = (year: number | string) => {
  const companyId = getCompanyId();
  const queryConfig = useProvisionConfigs(year);

  return useQuery({
    queryKey: [
      // QUERY_NAME.PROVISIONS,
      4,
      year,
    ],
    queryFn: () => fetchOrgs(companyId),
    ...queryConfig,
  });
};

export const useSubmitProvisions = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: SERVICES.PROVISIONS_SAVE,
        baseURL: process.env.REACT_APP_API_URL_V2,
        data: payload,
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.PROVISIONS]);
        // notification["success"]({
        //   message: "保存しました",
        // });
      },
    },
  );
};
